// extracted by mini-css-extract-plugin
module.exports = {"tourDetails":"tour-details-module__tourDetails___gogDO","label":"tour-details-module__label___2dB36"};